// BuyTogether.component.js
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Loader from 'Component/Loader';
import Image from 'Component/Image';
import './BuyTogether.style';
import '../FrequentlyBoughtTogetherWidget/FrequentlyBoughtTogetherWidget.style.scss'
export class BuyTogether extends PureComponent {
    render() {
        const {
            items,
            products,
            isLoading,
            default_display_currency_code: currency,
            onItemClick,
            onButtonClick
        } = this.props;

        // if (isLoading) {
        //     return <Loader isLoading />;
        // }
        if (!items.length) {
            return null;
        }

        // Compute total
        const totalValue = items
            .filter(item => products.some(p => p.sku === item.sku) && item.inStock)
            .reduce((sum, item) => {
                // choose special if valid
                const special = item.cartRuleSpecialPriceData;
                const now = Date.now();
                const hasSpecial = special
                    && Date.parse(special.startDate) <= now
                    && Date.parse(special.endDate) >= now;
                const price = hasSpecial
                    ? special.price
                    : item.price_range.minimum_price.final_price.value;
                return sum + parseFloat(price);
            }, 0);

        const totalPrice = totalValue.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + ' ' + currency;

        return (
            <div className="FrequentlyBoughtTogetherWidget">
                <h3 className="FrequentlyBoughtTogetherWidget-Title">
                    { __('Frequently bought together') }
                </h3>
                <div className="FrequentlyBoughtTogetherWidget-Content">
                    { isLoading && (
                        <div className="BuyTogether-Overlay">
                            <Loader isLoading />
                        </div>
                    ) }
                    <div className="FrequentlyBoughtTogetherWidget-Products">
                        {items.map((item, i) => {
                            const isSelected = products.some(p => p.sku === item.sku);
                            const inStock = item.inStock;
                            // pick display price
                            const special = item.cartRuleSpecialPriceData;
                            const now = Date.now();
                            const specialValid = special
                                && Date.parse(special.startDate) <= now
                                && Date.parse(special.endDate) >= now;
                            const displayPrice = specialValid
                                ? special.price
                                : item.price_range.minimum_price.final_price.value;

                            return (
                                <Fragment key={item.sku}>
                                    <div
                                        className={
                                            `FrequentlyBoughtTogetherWidget-ProductCard` +
                                            (isSelected ? ' Selected' : '') +
                                            (!inStock ? ' OutOfStock' : '')
                                        }
                                        onClick={() => inStock && onItemClick(item.sku)}
                                    >
                                        <div className="FrequentlyBoughtTogetherWidget-CheckboxWrapper">
                                            <input
                                                type="checkbox"
                                                checked={isSelected}
                                                disabled={!inStock}
                                                onChange={() => inStock && onItemClick(item.sku)}
                                            />
                                            {isSelected && (
                                                <span className="FrequentlyBoughtTogetherWidget-Checkmark">✓</span>
                                            )}
                                        </div>

                                        <Image
                                            src={item.small_image.url}
                                            alt={item.name}
                                            className="FrequentlyBoughtTogetherWidget-Image"
                                        />

                                        <div className="FrequentlyBoughtTogetherWidget-Details">
                                            <a
                                                href={item.url}
                                                className="FrequentlyBoughtTogetherWidget-Link"
                                            >
                                                <span className="FrequentlyBoughtTogetherWidget-Name">
                                                    {item.name}
                                                </span>
                                            </a>
                                            {!inStock && (
                                                <div className="FrequentlyBoughtTogetherWidget-OutOfStockLabel">
                                                    { __('Out of stock') }
                                                </div>
                                            )}
                                            <div className="FrequentlyBoughtTogetherWidget-Price">
                                                <span>
                                                    {displayPrice.toLocaleString('de-DE', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} {currency}
                                                </span>
                                                {specialValid && (
                                                    <del>
                                                        {item.price_range.minimum_price.regular_price.value.toLocaleString('de-DE', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })} {currency}
                                                    </del>
                                                )}
                                            </div>
                                        </div>


                                    </div>

                                    {i < items.length - 1 && (
                                        <div className="FrequentlyBoughtTogetherWidget-Separator">+</div>
                                    )}
                                </Fragment>
                            );
                        })}

                        <div className="FrequentlyBoughtTogetherWidget-Separator">=</div>

                        <div className="FrequentlyBoughtTogetherWidget-Action">
                            <div className="FrequentlyBoughtTogetherWidget-TotalPrice">
                                <strong>{ totalPrice }</strong>
                            </div>
                            <button
                                className="FrequentlyBoughtTogetherWidget-Button"
                                onClick={ onButtonClick }
                                disabled={ isLoading }
                            >
                                { __('Add Selected to Cart') }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BuyTogether.propTypes = {
    items: PropTypes.array.isRequired,
    products: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    default_display_currency_code: PropTypes.string.isRequired,
    onItemClick: PropTypes.func.isRequired,
    onButtonClick: PropTypes.func.isRequired
};

export default BuyTogether;
